import React from 'react'
import {
  StyledAddressContainer,
  StyledThumb,
  StyledAddress,
  StyledAddressRow,
} from './Address.styled'
import { useTranslation } from 'react-i18next'
import { ObjectType } from 'types/ApiResponse'
import efhIcon from 'assets/images/icons/efh_icon.svg'
import mfhIcon from 'assets/images/icons/mfh_icon.svg'
import etwIcon from 'assets/images/icons/etw_icon.svg'
import grdIcon from 'assets/images/icons/grd_icon.svg'

const Address = ({ data, onClickThumb }: any) => {
  const { t } = useTranslation()
  const getBuildingTypeLabel = () => {
    if (data.propertyDetails.objectType === ObjectType.PLOT_OF_LAND) {
      return data.propertyDetails?.objectType
        ? t(`objectType.${data.propertyDetails.objectType.toLowerCase()}`)
        : ''
    } else {
      return data.propertyDetails?.buildingType
        ? t(`buildingType.${data.propertyDetails.buildingType.toLowerCase()}`)
        : ''
    }
  }
  const getObjectTypeIcon = () => {
    switch (data.propertyDetails.objectType) {
      case ObjectType.HOUSE:
        return efhIcon
      case ObjectType.MULTI_FAMILY_HOUSE:
        return mfhIcon
      case ObjectType.APARTMENT:
        return etwIcon
      case ObjectType.PLOT_OF_LAND:
        return grdIcon
    }
  }

  return (
    <div>
      <StyledAddressContainer>
        {data?.propertyDetails?.reportImage ? (
          <StyledThumb onClick={onClickThumb}>
            <img src={`data:image/jpeg;base64,${data.propertyDetails.reportImage}`} alt="thumb" />
          </StyledThumb>
        ) : (
          <StyledThumb>
            <img src={getObjectTypeIcon()} alt="thumb" />
          </StyledThumb>
        )}
        <StyledAddress>
          <StyledAddressRow>
            {data.street} {data.houseNumber}
          </StyledAddressRow>
          <StyledAddressRow>
            {data.zip} {data.town}, {data.nation} | {getBuildingTypeLabel()}{' '}
            <p>{t(`objectType.${data.propertyDetails.objectType.toLowerCase()}.tag`)}</p>
          </StyledAddressRow>
          <StyledAddressRow>
            {data.lat?.toFixed(6)}, {data.lng?.toFixed(6)}
          </StyledAddressRow>
        </StyledAddress>
      </StyledAddressContainer>
    </div>
  )
}

export default Address
